const TEXTS = {
  ITEM_LIST_SELECT_ALl: 'Включить все',
  ITEM_LIST_SELECT_NONE: 'Сбросить',
};

export default TEXTS;
